export enum TokenType {
  ENDMARKER = 0,
  NAME = 1,
  NUMBER = 2,
  BIGINT = 3,
  STRING = 4,
  NEWLINE = 5,
  INDENT = 6,
  DEDENT = 7,
  LPAR = 8,
  RPAR = 9,
  COLON = 10,
  DOUBLECOLON = 11,
  COMMA = 12,
  PLUS = 13,
  MINUS = 14,
  BANG = 15,
  STAR = 16,
  SLASH = 17,
  VBAR = 18,
  AMPER = 19,
  LESS = 20,
  GREATER = 21,
  EQUAL = 22,
  PERCENT = 23,
  DOUBLEEQUAL = 24,
  NOTEQUAL = 25,
  LESSEQUAL = 26,
  GREATEREQUAL = 27,
  DOUBLESTAR = 28,
  COMPLEX = 29,
  AND = 30,
  OR = 31,
  FOR = 32,
  WHILE = 33,
  NONE = 34,
  TRUE = 35,
  FALSE = 36,
  IS = 37,
  NOT = 38,
  ISNOT = 39,
  PASS = 40,
  DEF = 41,
  LAMBDA = 42,
  FROM = 43,
  DOUBLESLASH = 44,
  BREAK = 45,
  CONTINUE = 46,
  RETURN = 47,
  ASSERT = 48,
  IMPORT = 49,
  GLOBAL = 50,
  NONLOCAL = 51,
  IF = 52,
  ELSE = 53,
  ELIF = 54,
  IN = 55,
  NOTIN = 56,
  RSQB = 57,
  LSQB = 58,
  ELLIPSIS = 59,
  SEMI = 60,
  DOT = 61,
  LBRACE = 62,
  RBRACE = 63,
  TILDE = 64,
  CIRCUMFLEX = 65,
  LEFTSHIFT = 66,
  RIGHTSHIFT = 67,
  PLUSEQUAL = 68,
  MINEQUAL = 69,
  STAREQUAL = 70,
  SLASHEQUAL = 71,
  PERCENTEQUAL = 72,
  AMPEREQUAL = 73,
  VBAREQUAL = 74,
  CIRCUMFLEXEQUAL = 75,
  LEFTSHIFTEQUAL = 76,
  RIGHTSHIFTEQUAL = 77,
  DOUBLESTAREQUAL = 78,
  DOUBLESLASHEQUAL = 79,
  AT = 80,
  ATEQUAL = 81,
  RARROW = 82,
  COLONEQUAL = 83,
  OP = 84,
  AWAIT = 85,
  ASYNC = 86,
  TYPE_IGNORE = 87,
  TYPE_COMMENT = 88,
  YIELD = 89,
  WITH = 90,
  DEL = 91,
  TRY = 92,
  EXCEPT = 93,
  FINALLY = 94,
  RAISE = 95,
  CLASS = 96,
}

/**
 * Represents a token produced by the lexer.
 */
export class Token {
  /**
   * The type of the token (e.g., `TokenType.NAME`, `TokenType.NUMBER`, etc.)
   */
  type: TokenType;

  /**
   * The string value of the token as it appears in the source code (e.g., for a token representing the number `42`, the lexeme would be the string `"42"`).
   */
  lexeme: string;

  /**
   * The line number where the token appears in the source code (1-based).
   */
  line: number;

  /**
   * The column number where the token starts in the source code (0-based).
   */
  col: number;

  /**
   * The index of the token in the source code (0-based).
   */
  indexInSource: number;

  /**
   * True for tokens fabricated at runtime (e.g. implicit `range()` bounds) that do not
   * correspond to real source text. Consumers that slice source text by position (like the
   * CSE Machine visualizer) must not treat these as real, even though their `indexInSource`
   * may coincide with a genuine position (e.g. 0).
   */
  synthetic?: boolean;

  constructor(type: TokenType, lexeme: string, line: number, col: number, indexInSource: number) {
    this.type = type;
    this.lexeme = lexeme;
    this.line = line;
    this.col = col;
    this.indexInSource = indexInSource;
  }
}
